export class TrasactionSetupInput {
  salemMerchantId!: string;
}
